<app-work-mass-work
    class="pt-2 subpage-content"
    [personIdInput]="folderStore.folder()?.personId || null"
    (closeCallback)="dialogRef.close()"
></app-work-mass-work>

<div #dialogFooter></div>
